// Formats a US phone number as the user types into 123-456-7890.
// Strips all non-digits, caps at 10 digits, and inserts dashes after the
// third and sixth digit so the field is masked/dummy-proof.
export function formatPhone(input: string): string {
  const digits = (input || '').replace(/\D/g, '').slice(0, 10);
  const parts: string[] = [];
  if (digits.length > 0) parts.push(digits.slice(0, 3));
  if (digits.length > 3) parts.push(digits.slice(3, 6));
  if (digits.length > 6) parts.push(digits.slice(6, 10));
  return parts.join('-');
}
